import { EServerPath } from '~/models/api'

const queryKeys = {
  user: (id: string) => [EServerPath.adminUserFromOrg, id],
}

export default queryKeys
